<template>
    <div class="row">
        <div class="col-md-12 mb-4 mt-3">
            <el-card shadow="hover">
                <div slot="header" class="px-1">
                    <h6 class="text-center m-0">Sales Achievement (Rp)</h6>
                </div>

                <div>
                    <TableSalesValueAchievement />
                </div>
            
            </el-card>
        </div>
    </div>
</template>


<script>
import Fuel from '@/components/page/Fuel.js'
import TableSalesValueAchievement from '@/views/pages/FuelTracking/FuelTrackingSales/TableSalesValueAchievement.vue'
import TableSalesVolumeAchievement from '@/views/pages/FuelTracking/FuelTrackingSales/TableSalesVolumeAchievement.vue'
import TableAverageSpd from '@/views/pages/FuelTracking/FuelTrackingSales/TableAverageSpd.vue'

export default {
    extends:Fuel,
	components: {
        TableSalesValueAchievement,
        //TableSalesVolumeAchievement,
        //TableAverageSpd,
    },
    //props: ['tabIndex','tabName', 'tabLabel'],
    computed:{

	},
    watch:{

    },
    mounted() {
        this.$emit('childrenRoute');
    },
    data() {
		return {

        }
    },
    methods:{

    }
}
</script>
